var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty flex-column"},[_c('el-image',{attrs:{"src":_vm.emptyBg,"fit":"cover"}}),_c('p',[_vm._v(_vm._s(_vm.emptyText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }